import { ApplicationConfig, importProvidersFrom, inject } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { NgSelectModule } from "@ng-select/ng-select";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { ConfigurationService } from "./services/configuration-service/configuration.service";
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { AuthenticationService } from "./auth/authentication-service/authentication.service";
import { UserAuthenticationDataManagerService } from "./auth/user-authentication-data-manager-service/user-authentication-data-manager.service";
import { ActionsService } from "./services/actions-service/actions.service";
import { DefaultOptions, InMemoryCache } from "@apollo/client";
import { HttpLink } from "apollo-angular/http";
import { provideApollo } from "apollo-angular";
import { environment } from "src/environments/environment";
import { AuthenticationHeaderAdderInterceptor } from "./interceptors/authentication-header-adder.interceptor";
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";

import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts/core';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import { DatasetComponent, DataZoomComponent, DataZoomSliderComponent, GridComponent, LegendComponent, TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
echarts.use([BarChart, DataZoomSliderComponent, DatasetComponent, TooltipComponent, DataZoomComponent, LineChart, GridComponent, CanvasRenderer, LegendComponent, PieChart]);

const uri = environment.apiURL + '/api/chronos'; //

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
  },
  query: {
    fetchPolicy: 'network-only',
  },
}

export function createApollo() {
  const httpLink = inject(HttpLink);

  return {
    link: httpLink.create({ uri: uri }),
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions
  };
}


export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, NgSelectModule, CommonModule, ReactiveFormsModule, BrowserAnimationsModule),
    ConfigurationService,
    HttpClient,
    AuthenticationService,
    UserAuthenticationDataManagerService,
    ActionsService,
    HttpLink,
    provideApollo(createApollo),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationHeaderAdderInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideEchartsCore({ echarts }),
    provideRouter(routes)
  ]
}
